export const FETCH_SCHEMES_REQUEST = "FETCH_SCHEMES_REQUEST";
export const FETCH_SCHEMES_SUCCESS = "FETCH_SCHEMES_SUCCESS";
export const FETCH_SCHEMES_FAILURE = "FETCH_SCHEMES_FAILURE";
